import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loggedInState: localStorage.getItem("isLoggedIn") === "true",
  user: null,
  token: null,
  // isLoggedIn: false,
};

const userSlice = createSlice({

  name: "user",
  initialState,
  reducers: {
    setAuthUser: (state, action) => {
      state.loggedInState = true;
      localStorage.setItem("isLoggedIn", "true");
        if (!action.payload) {
          console.error("🚨 setUser received an undefined payload:", action);
          return;
        }
        console.log("✅ Setting user in Redux:", action.payload);
        state.user = action.payload;
        
      },
    logout(state) {
        state.loggedInState = false;
        state.user = null;
        localStorage.removeItem("isLoggedIn");
        console.log("logout is called",state.loggedInState)
    },
  },
});

export const { setAuthUser, logout } = userSlice.actions;
export default userSlice.reducer;
